const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return localStorage.getItem("d_c_c_t");
}

export async function fetchAllDataApi(url: string, options: RequestInit = {}): Promise<any> {
    try {
  
      
      //const token = getToken();
     // //const csrfToken = await getCsrfToken();
  
    
    
  
      const response = await fetch(`${BASE_URL}/${url}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
      //    ...(token ? { Authorization: `Bearer ${token}` } : {}),
      //    "X-CSRF-TOKEN": csrfToken,
        },
      //  credentials: "include"
      });
  
      
  
      const data = await response.json();
      
      ////console.log("Response Data:", data);
  
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
       
        //toast(data.message || "Failed to fetch");
      }
  
      return data;
    } catch (error: any) {
      //console.error("Fetch Error:", error);
      throw new Error(error.message || "Failed to fetch");
    }
  }

  export async function getLatestMessages(url: string, options: RequestInit = {}): Promise<any> {
    try {
      const token = getToken();
  
      const response = await fetch(`${BASE_URL}/${url}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
          }
  
      return data;
    } catch (error: any) {
      //console.error("Fetch Error:", error);
      throw new Error(error.message || "Failed to fetch");
    }
  }

  export async function fetchAllNotifications(perPage: number, pageNo: number, search: string): Promise<any> {
    try {
      const token = getToken();
  
      const response = await fetch(`${BASE_URL}/notifications/user-notifications?search=${search}&perPage=${perPage}&pageNo=${pageNo}`, {
        headers: {
          'Content-Type': 'application/json',
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
          }
  
      return data;
    } catch (error: any) {
      //console.error("Fetch Error:", error);
      throw new Error(error.message || "Failed to fetch");
    }
  }

  export async function getUnseenNotifications(userId: string): Promise<any> {
    try {
      const token = getToken();
  
      const response = await fetch(`${BASE_URL}/notifications/unseen?userId=${userId}`, {
        headers: {
          'Content-Type': 'application/json',
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
      }
  
      return data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to fetch unseen notifications");
    }
  }

  export async function seenNotification(userId: string): Promise<any> {
    try {
      const token = getToken();
  
      const response = await fetch(`${BASE_URL}/notifications/seen`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ userId }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
      }
  
      return data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to mark notifications as seen");
    }
  }

